<template>
    <div class="discover-modal" v-if="!(parseInt(this.$route.query.popup) === 0) && modal">
        <el-drawer
            :append-to-body="true"
            :modal-append-to-body="false"
            :visible.sync="drawer"
            :wrapperClosable="false"
            direction="btt"
            size="92%">
            <div class="drawer-warp">
                <div class="modal-title">
                    <i class="el-icon-close close-button" @click="close()"/>
                    <span class="draw-title">What's Your Job Preference? </span>
                    <span class="draw-reset" @click="reset()">Reset</span>
                </div>
                <div class="modal-body">
                    <div class="body-warp">
                        <div class="item">
                            <p class="item-title">
                                State
                            </p>
                            <div class="item-select">
                                <el-select :popper-append-to-body="false" ref="select" class="item-input" v-model="value" placeholder=""><!--@change="downKey"-->
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item">
                            <p class="item-title">
                                Driver Type
                            </p>
                            <div class="item-label">
                            <span
                                v-for="(item, i) in driverType"
                                :class="item.status ? 'label_active' : ''"
                                :style="{marginRight: i % 2 === 0 ? '2%' : 0}"
                                :key="i"
                                @click="changeDriverType(i)"
                            >
                                {{item.name}}
                            </span>
                            </div>
                        </div>
                        <div class="item">
                            <p class="item-title">
                                Freight Type
                            </p>
                            <div>
                                <div class="item-label">
                                <span
                                    v-for="(it, i) in types[0].value"
                                    :class="it.status ? 'label_active' : ''"
                                    :style="{marginRight: i % 2 === 0 ? '2%' : 0}"
                                    :key="i"
                                    @click="changeFrightType(0, i)"
                                >
                                    {{it.name}}
                                </span>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <p class="item-title">
                                Driving Experience
                            </p>
                            <p class="slider-value" v-if="this.sliderValue[0] !== 0 && this.sliderValue[1] === 7">
                                ≥ {{this.years[this.sliderValue[0]]}} {{this.sliderValue[0] > 2 ? 'years' : 'year'}}
                            </p>
                            <p class="slider-value" v-else-if="this.sliderValue[0] === 0 && this.sliderValue[1] === 7">Min-Max
                                Yrs</p>
                            <p class="slider-value" v-else>
                                {{this.years[this.sliderValue[0]]}}-{{this.years[this.sliderValue[1]]}}
                                {{this.sliderValue[1] > 2 ? 'years' : 'year'}}
                            </p>
                            <el-slider
                                :show-tooltip="false"
                                v-model="sliderValue"
                                range
                                :max="7">
                            </el-slider>
                        </div>
                        <div class="item">
                            <p class="item-title">
                                Driving Distance
                            </p>
                            <div>
                                <div class="item-label">
                                <span
                                    v-for="(it, i) in types[1].value"
                                    :class="it.status ? 'label_active' : ''"
                                    :style="{marginRight: i % 2 === 0 ? '2%' : 0}"
                                    :key="i"
                                    @click="changeFrightType(1, i)"
                                >
                                    {{it.name}}
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <el-button :loading="loading" class="footer-button" type="primary" @click="savePerferences()">Save</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    import {stateOptions, driverType, types} from "@/tools/jobPreferencesData";
    import {getPerferences, addPerferences} from "@/api/jobPreferences";
    import {getCookies} from "@/tools/cookie";
    // import vconsole from 'vconsole';
    import mixpanel from '@/utils/mixpanel.js'
    export default {
        name: "Modal",
        props: ['page', 'saveInfo'],
        data() {
            const {userId, deviceId} = getCookies();
            return {
                haveId: userId || deviceId,
                modal: false,
                drawer: false, // this.visible
                options: stateOptions,
                value: '',
                sliderValue: [0, 7],
                years: ['0', '0.5', '1', '2', '3', '4', '5', '5+'],
                types: types,
                driverType: driverType,
                loading: false,
                data: {}
            }
        },
        created() {
            //new vconsole()
            mixpanel.initMixpanel(process.env['VUE_APP_MIX_KEY']);
            if (this.haveId) {
                getPerferences().then(res => {
                    console.log(res.data.data, '==========')
                    const data = res.data.data
                    this.data = data
                    // data.state && data.driverType && data.drivingExperience && data.freightType.length && data.drivingDistance.length
                    if (data.state && data.state !== 'All States' && data.driverType && data.freightType.length) {
                        if (this.saveInfo) this.saveInfo(data)
                        this.modal = false
                        this.drawer = false
                    } else {
                        console.log(this.page)
                        mixpanel.track(this.page, {'Outcome': 'Preference Popup'})
                        this.showModal()
                        this.value = data.state && data.state !== 'All States' ? data.state : ''
                        if (data.driverType) this.driverType.forEach(item => {
                            if (item.name === data.driverType) item.status = true
                        })
                        if (data.drivingExperience) this.sliderValue = [this.years.indexOf(data.drivingExperience.match(/(\S*)-/)[1]), this.years.indexOf(data.drivingExperience.match(/-(\S*)/)[1])]
                        if (data.freightType.length) this.types.forEach(item => {
                            if (item.key === 'freightType') item.value.forEach(it => {
                                if (data.freightType.indexOf(it.name) !== -1) it.status = true
                            })
                        })
                        if (data.drivingDistance.length) this.types.forEach(item => {
                            if (item.key === 'drivingDistance') {
                                item.value.forEach(it => {
                                    if (data.drivingDistance.indexOf(it.name) !== -1) it.status = true
                                })
                            }
                        })
                    }
                }).catch(() => {
                    if (this.saveInfo) this.saveInfo(this.data)
                })
            } else {
                setTimeout(() => {
                    console.log(this.saveInfo, '============')
                    if (this.saveInfo) this.saveInfo(this.data)
                }, 500)
            }
        },
        mounted() {},
        watch: {
            sliderValue(newVal, oldVal) {
                if (newVal[0] === newVal[1]) {
                    this.sliderValue = oldVal
                }
            }
        },
        methods: {
            /*downKey(value) {
                console.log(value, '-----------')
                this.$refs.select.blur()
                console.log(this.$refs.select)
            },*/
            showModal() {
                document.querySelector('body').style.position = 'fixed'
                document.querySelector('body').style.height = '100%'
                this.modal = true
                this.drawer = true
            },
            changeDriverType(i) {
                this.driverType.forEach((item, index) => {
                    if (i === index) {
                        item.status = true
                    } else {
                        item.status = false
                    }
                })
            },
            changeFrightType(index, i) {
                const bool = this.types[index].value[i].status
                this.types[index].value[i].status = !bool
            },
            close() {
                document.querySelector('body').style.position = 'static'
                document.querySelector('body').style.height = 'auto'
                this.drawer = false
                if (this.saveInfo) this.saveInfo(this.data)
                mixpanel.track(this.page, {'Outcome': 'Preference Close'})
            },
            reset() {
                mixpanel.track(this.page, {'Outcome': 'Preference Reset'})
                this.value = ''
                this.sliderValue = [0, 10]
                this.driverType.map(item => item.status = false)
                this.types.forEach(item => {
                    item.value.map(it => it.status = false)
                })
            },
            savePerferences() {
                this.loading = true
                mixpanel.track(this.page, {'Outcome': 'Preference Save'})
                const drivingExperience = `${this.years[this.sliderValue[0]]}-${this.years[this.sliderValue[1]]}`
                let driverType = '', freightType = [], drivingDistance = []
                this.driverType.forEach(item => {
                    if (item.status) driverType = item.name
                })
                this.types.forEach(item => {
                    if (item.key === 'freightType') item.value.forEach(it => {
                        if (it.status) freightType.push(it.name)
                    })
                    if (item.key === 'drivingDistance') item.value.forEach(it => {
                        if (it.status) drivingDistance.push(it.name)
                    })
                })
                const data = {
                    state: this.value ? this.value : 'All States',
                    driverType: driverType,
                    drivingExperience: drivingExperience,
                    freightType: freightType,
                    drivingDistance: drivingDistance
                }
                console.log(data)
                addPerferences(data).then(res => {
                    this.loading = false
                    if (res.data.code === 0) {
                        document.querySelector('body').style.position = 'static'
                        document.querySelector('body').style.height = 'auto'
                        this.drawer = false
                        if (this.saveInfo) this.saveInfo(data)
                    }
                }).catch(() => {
                    this.loading = false
                    this.$message.error('save error')
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @font-face {
        font-family: SFProText-Bold;
        src: url(../../assets/fonts/SF-Pro-Text-Bold.otf);
    }
    @font-face {
        font-family: SFProText-Semibold;
        src: url(../../assets/fonts/SF-Pro-Text-Semibold.otf);
    }
    @font-face {
        font-family: SFProText-Medium;
        src: url(../../assets/fonts/SF-Pro-Text-Medium.otf);
    }
    .discover-modal {
        font-size: 16px !important;
        color: #141A42;
        /*position: relative;*/
        /deep/ .el-drawer__header {
            display: none;
        }
        /deep/ .el-drawer__open .el-drawer {
            border-radius: 30px 30px 0 0;
            top: 8%;
            /*position: relative;*/
        }
        /deep/ .el-drawer__body {
            /*overflow-y: scroll;*/
            overflow-x: hidden;
        }
        .modal-title {
            position: fixed;
            -webkit-overflow-scroll: touch;
            top: 7.5%;
            z-index: 100;
            width: 100%;
            padding: 18px 15px;
            border-bottom: 1px solid #e7ebf3;
            background: #fff;
            height: 60px;
            overflow: hidden;
            line-height: 0;
            border-radius: 25px 25px 0 0;
            .close-button {
                color: #141A42;
                font-weight: 900;
                font-size: 18px;
            }
            .draw-title {
                display: inline-block;
                font-family: SFProText-Bold;
                text-align: center;
                font-size: 15px;
                width: calc(100% - 60px);
                margin: 0 auto;
            }
            .draw-reset {
                display: inline-block;
                font-family: SFProText-Semibold;
                font-size: 14px;
                color: #168cd8;
            }
        }
        .modal-body {
            margin: 75px 15px 80px;
            border-radius: 30px 30px 0 0;
            .body-warp {
                max-width: 500px;
                margin: 0 auto;
            }
            .item {
                padding-bottom: 15px;
                .item-title {
                    font-family: SFProText-Bold;
                    font-size: 14px;
                    margin-bottom: 15px;
                }
                .item-select{
                    border: 1px solid #e7ebf3;
                    border-radius: 3px;
                    margin-bottom: 10px;
                }
                .item-input.el-select {
                    width: 100%;
                    /deep/.el-scrollbar {
                        > .el-scrollbar__bar {
                            opacity: 1 !important;
                        }
                    }
                    /deep/ .el-input__inner {
                        height: 35px;
                        background: transparent;
                        font-family: SFProText-Medium;
                        border: none;
                    }
                    /deep/ .el-input__icon {
                        line-height: 35px;
                    }
                }
                .slider-value {
                    font-family: SFProText-Medium;
                    font-size: 14px;
                    color: rgb(67, 72, 104);
                    margin-bottom: 10px;
                }
                /deep/ .el-slider__bar {
                    background: #168cd8;
                }
                /deep/ .el-slider__button-wrapper {
                    /deep/ .el-slider__button {
                        border: 2px solid #168cd8 !important;
                    }
                }
                .item-label {
                    span {
                        display: inline-block;
                        font-family: SFProText-Medium;
                        width: 49%;
                        overflow: hidden;
                        height: 35px;
                        border: 1px solid #e7ebf3;
                        border-radius: 3px;
                        color: rgb(67, 72, 104);
                        text-align: center;
                        line-height: 35px;
                        font-size: 14px;
                        margin-bottom: 10px;
                    }
                    .label_active {
                        color: #168cd8;
                        border-color: #168cd8;
                        background: rgb(229, 243, 251);
                    }
                }
            }
        }
        .modal-footer {
            position: fixed;
            -webkit-overflow-scroll: touch;
            z-index: 2000;
            width: 100%;
            border-top: 1px solid #e7ebf3;
            bottom: 0 !important;
            padding: 15px 15px;
            text-align: center;
            background: #fff;
            .footer-button {
                width: 100%;
                height: 45px;
                background: #168cd8;
                max-width: 500px;
                text-align: center;
            }
        }
    }
</style>
